<template>
  <div id="app">
    <top-menu></top-menu>
    <router-view></router-view>
    <footer></footer>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="sass">
@import "./styles/_vars.sass"

html, body, textarea, select, input, button 
  font: 12px/18px "微軟正黑體","Microsoft Jhenghei", Helvetica, Arial, sans-serif

html
  width: 100vw

body
  width: 100vw
  overflow-x: hidden
  -webkit-transition: none
  -moz-transition: none
  -o-transition: none
  transition: none

img
  width: 100%

a
  text-decoration: none
  color: $font-grey

  &:hover
    text-decoration: none

.underline
  text-decoration: underline

  &:hover
    color: $font-grey
    text-decoration: none

*
  -webkit-transition: .4s ease-in-out
  -moz-transition: .4s ease-in-out
  -o-transition: .4s ease-in-out
  transition: .4s ease-in-out
</style>



// WEBPACK FOOTER //
// App.vue?584663c4